// extracted by mini-css-extract-plugin
module.exports = {"Link":"DownloadLink_Link__3MCeZ"};